/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Notify_Ev_CommentInputs */

const en_fw_notify_ev_comment = /** @type {(inputs: Fw_Notify_Ev_CommentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment`)
};

const id_fw_notify_ev_comment = /** @type {(inputs: Fw_Notify_Ev_CommentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Komentar`)
};

/**
* | output |
* | --- |
* | "Comment" |
*
* @param {Fw_Notify_Ev_CommentInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_notify_ev_comment = /** @type {((inputs?: Fw_Notify_Ev_CommentInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Notify_Ev_CommentInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_notify_ev_comment(inputs)
	return en_fw_notify_ev_comment(inputs)
});